/**
 * 获取文件名后缀
 */
export const getNameSuffix = function (fileName) {
  let lastIndex;
  return typeof fileName === 'string' && (lastIndex = fileName.lastIndexOf(".")) !== -1
    ? fileName.substr(lastIndex)
    : "";
};



// WEBPACK FOOTER //
// ./src/js/utils/fileUtils.js